module.exports = __webpack_public_path__ + "media/images/icons/icon_checklist_green-b308bd362c2d2f47aac78454cdd6ee57.svg";